import { useState, useMemo } from 'react'
import { Stack, Button, Box, TextField } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { useTranslation } from 'react-i18next';

export interface IBobForecastCreateEntryDialog {
    open : boolean;
    airlineList : {label: string, value: string}[];
    cancelAction : () => void;
    createAction : (airline : string, dep : string, dest : string) => void;
}

function BobForecastCreateEntryDialog(props : IBobForecastCreateEntryDialog) {
    const { t } = useTranslation();
    
    const [ airlineCode, setAirlineCode] = useState('');
    const [ dep, setDep] = useState('');
    const [ dest, setDest] = useState('');
    
    const [ airlineCodeError, setAirlineCodeError] = useState(true);
    const [ depError, setDepError] = useState(true);
    const [ destError, setDestError] = useState(true);

    const hasErrors = useMemo(() => {
        return airlineCodeError || depError || destError;
    }, [airlineCodeError, depError, destError]);

    const handleAirlineCode = (value : string | undefined) => {
        setAirlineCode(value ?? '');
        setAirlineCodeError(value === undefined || value === '');
    }  

    const handleDep = (value : string | undefined) => {
        setDep(value ?? '');
        setDepError(value === undefined || value === '');
    }   

    const handleDest = (value : string | undefined) => {
        setDest(value ?? '');
        setDestError(value === undefined || value === '');
    }   

    return (
        <div>
        <Dialog open={props.open} onClose={props.cancelAction}>
            <DialogTitle>Create BoB Forecast</DialogTitle>
            <DialogContent>
                <DialogContentText>
                    You are going to create a new route to maintain BoB forecast entries.
                </DialogContentText>
                <Box>
                <Stack spacing={2} direction="column" sx={{ marginBottom: 4, marginTop: 1, paddingTop:2 }}>
                    <FormControl sx={{minWidth: 200 }} size="small">
                        <InputLabel id="airline-label">Airline</InputLabel>
                        <Select
                            labelId="airline-label"
                            id="airline-select"
                            value={airlineCode}
                            error={airlineCodeError}
                            label="Type"
                            onChange={(e) => handleAirlineCode(e.target.value) }>
                                { props.airlineList && props.airlineList.map((o)=> (
                                    <MenuItem  key={o.value} value={o.value}>{o.label}</MenuItem>
                                ))}
                        </Select>
                    </FormControl>
                    <FormControl sx={{minWidth: 200 }} size="small">
                        <TextField
                                    type="text"
                                    variant='outlined'
                                    color='secondary'
                                    label={t('Departure')}
                                    onChange={e => handleDep(e.target.value)}
                                    value={dep}
                                    error={depError}
                                    helperText={depError ? 'Please departure station' : ''}
                                    fullWidth
                                    size="small"
                        />
                    </FormControl>
                    <FormControl sx={{minWidth: 200 }} size="small">
                        <TextField
                                    type="text"
                                    variant='outlined'
                                    color='secondary'
                                    label={t('Destination')}
                                    onChange={e => handleDest(e.target.value)}
                                    value={dest}
                                    error={destError}
                                    helperText={destError ? 'Please destination station' : ''}
                                    fullWidth
                                    size="small"
                        />
                    </FormControl>
                </Stack>
                </Box>
            </DialogContent>
            <DialogActions>
                <Button onClick={props.cancelAction}>Cancel</Button>
                <Button disabled={hasErrors} onClick={(e) => props.createAction(airlineCode, dep, dest) }>Create</Button>
            </DialogActions>
      </Dialog>
      </div>
    )
}

export default BobForecastCreateEntryDialog;